import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    token: null,
    refreshToken: null,
    account: null,
    files: [],
    /** false until silent refresh attempt finishes (avoids F5 redirect to login while cookie session restores) */
    sessionInitialized: false,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setAuthTokens(state, action) {
            state.token = action.payload.token;
            // Refresh token is HttpOnly (not stored in JS / Redux)
            state.refreshToken = action.payload.refreshToken ?? null;
        },
        setSessionInitialized(state, action) {
            state.sessionInitialized = action.payload;
        },
        setAccount(state, action) {
            state.account = action.payload;
        },
        setWelcomeDialog(state, action) {
            state.account = {
                ...state.account,
                is_first_login: action.payload,
            };
        },
        setFiles(state, action) {
            state.files = action.payload;
        },
        logout(state) {
            state.account = null;
            state.refreshToken = null;
            state.token = null;
            state.files = [];
            state.sessionInitialized = true;
        },
    },
});

export const { setAuthTokens, setAccount, logout, setWelcomeDialog, setFiles, setSessionInitialized } =
    authSlice.actions;
export default authSlice.reducer;
